import React from "react";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import {
  Typography,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Stack,
  useMediaQuery,
  Box,
  TextField,
  Button,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Auth } from "../../app/slices/authSlice";
import LoadingButton from "@mui/lab/LoadingButton";
import { BiLogInCircle } from "react-icons/bi";

const AuthWrapper1 = styled("div")(({ theme }) => ({
  // backgroundColor: theme.palette.primary.light,
  minHeight: "100vh",
}));

const Login = () => {
  const dispatch = useDispatch();
  const { auth, form } = useSelector((state) => state.auth);

  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));

  const { control, reset, watch, register, handleSubmit, setValue } = useForm({
    defaultValues: form,
  });
  const onSubmit = (data) => {
    dispatch(Auth.login(data));
  };

  return (
    <AuthWrapper1>
      <Grid
        container
        direction="column"
        justifyContent="flex-end"
        // sx={{ minHeight: "100vh" }}
      >
        <Grid item xs={12}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={
              {
                // minHeight: "calc(100vh - 68px)",
              }
            }
          >
            <Grid
              item
              sx={{
                m: { xs: 1, sm: 3 },
                mb: 0,
              }}
            >
              <Box>
                <Card
                  sx={{
                    maxWidth: { xs: 400, lg: 475 },
                    margin: { xs: 2.5, md: 3 },
                    // backgroundColor:theme.palette.primary.main
                  }}
                >
                  <CardContent>
                    <Grid
                      container
                      spacing={2}
                      sx={{
                        p: 2,
                      }}
                    >
                      <Grid
                        item
                        xs={12}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={require("../../assets/images/logo.png")}
                          alt="logo"
                          height={75}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Grid item>
                            <Stack alignItems="center" justifyContent="center">
                              <Typography
                                gutterBottom
                                color={theme.palette.primary.main}
                                variant={matchDownSM ? "h5" : "h4"}
                                fontWeight={"bold"}
                              >
                                Welcome Back
                              </Typography>
                              <Typography
                                variant="subtitle1"
                                textAlign={"center"}
                                color={theme.palette.primary.light}
                              >
                                To continue, Login with your email and password
                              </Typography>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <Controller
                                name="email"
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    required
                                    label="Email"
                                    fullWidth
                                    sx={{
                                      ...theme.typography.customInput,
                                    }}
                                    {...field}
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <Controller
                                name="password"
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    required
                                    type={"password"}
                                    label="Password"
                                    sx={{
                                      ...theme.typography.customInput,
                                    }}
                                    fullWidth
                                    {...field}
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <Box sx={{ mt: 2 }}>
                                <LoadingButton
                                  loading={auth.loading}
                                  loadingPosition="start"
                                  startIcon={<BiLogInCircle />}
                                  size="large"
                                  fullWidth
                                  type="submit"
                                  variant="contained"
                                  color="primary"
                                >
                                  Login
                                </LoadingButton>
                              </Box>
                            </Grid>
                          </Grid>
                        </form>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AuthWrapper1>
  );
};

export default Login;
